import React from "react";

const KeyBtn = ({ label, onPress, backspace }) => {
    let clickHandler = () => {
        onPress(label);
    };
    if (label === "SPACE") {
        clickHandler = () => {
            onPress(" ");
        };
    }
    if (label === "backspace") {
        clickHandler = (e) => {
            onPress(e);
        };
    }

    return (
        <div onClick={clickHandler}>
            <button className='text-white bg-main-700 border-2 border-main-white rounded-lg text-2xl w-full sm:w-auto px-8 py-4 text-center'>
                {label}
            </button>
        </div>
    );
};

export default KeyBtn;
